import { getTransactionTypeChipsMapping } from "./transactionTypeChipConfig.js";
import { localizedTransactionFilterType } from "../../intl/shared-resources/transactionType.js";
import { ChipVariant } from "../../components/chip/types.js";
const getTransactionFilterTypeChipsMapping = (chipType) => ({
  ...getTransactionTypeChipsMapping(chipType),
  FEES: {
    label: localizedTransactionFilterType.FEES,
    chipType,
    chipVariant: ChipVariant.Default
  }
});
export {
  getTransactionFilterTypeChipsMapping
};
//# sourceMappingURL=transactionFilterTypeChipConfig.js.map
